<template>
    <div @click="handleClick" class="pm-dashbord-btn-secondary">

        <span class="pm-dashbord-btn-secondary-icon-container" >
            <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
            <mdi v-if="item.mdi" style="color: #666;" :size="32">{{ item.mdi }}</mdi>

            <!-- <span v-if="item.free && IAP.status.includes('offeringsLoaded') && !IAP.hasAccessToComponent('smart')" class="pm-dashbord-btn-secondary-badge">
                FREE
            </span> -->
        </span>
        {{ item.title }}
    </div>
</template>
<style>
.pm-dashbord-btn-secondary-badge {
    position: absolute;
    transform: rotate(-45deg);

    top: 4px;
    left: -10px;
    font-size: 9px;
    font-weight: 600;
    background: green;
    color: white;
    line-height: 14px;
    padding: 0 12px;
    transform-origin: center;
}
.pm-dashbord-btn-secondary {
    letter-spacing: -0.5px;
    font-size: 13px;
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    overflow: visible;
}
.pm-dashbord-btn-secondary-icon-container {
    box-shadow: 0 0 10px rgba(0, 0, 0, .08), inset -4px  4px 10px -5px rgba(0,0,0,.1);
    border: 1px solid #fff;
    text-align: center;
    display: inline-block;
    width: 60px;
    height: 60px;
    line-height: 60px;
    background: rgb(255, 255, 255);
    border-radius: 12px;
    margin-bottom: 6px;
    font-size: 32px;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
}
.pm-dashbord-btn-secondary-icon-container .v-icon {
    font-size: 32px;
}

@media (min-width: 700px) {
    .pm-dashbord-btn-secondary {
        font-size: 15px;
    }

    .pm-dashbord-btn-secondary .pm-dashbord-btn-secondary-icon {
        width: 74px;
        height: 74px;
        line-height: 74px;
        font-size: 42px;
        margin-bottom: 6px;
    }
}
</style>
<script>
export default {
    props: {
        item: {
            type: Object
        }
    },
    data: () => ({
        IAP: window.IAP,
    }),
    methods: {
        handleClick() {
            if (this.item.link) this.$router.push(this.item.link);
            if (typeof this.item.callback === "function") this.item.callback();
        }
    }
};
</script>
